export const MODELS_COLLECTION = 'MODELS_COLLECTION';
export const MODEL_YEARS = 'MODEL_YEARS';
export const MODEL_YEAR_POWERS_TRIMS = 'MODEL_YEAR_POWERS_TRIMS';
export const PAYMENT_CALCULATOR = 'PAYMENT_CALCULATOR';
export const VEHICLE_PAYMENTS = 'VEHICLE_PAYMENTS';
export const OPTIONS_VALIDATION = 'OPTIONS_VALIDATION';

export default {
    MODELS_COLLECTION,
    MODEL_YEARS,
    MODEL_YEAR_POWERS_TRIMS,
    PAYMENT_CALCULATOR,
    VEHICLE_PAYMENTS,
    OPTIONS_VALIDATION,
};
